import React from 'react'
// import { LugarA } from '../../ADMINISTRADOR/ui/LugarA/LugarA'

export const Lugar = () => {
  return (
    <div> 
      <div className='ciudadIzquierdaI'>
        <section>
        <img className='imagenciudadI' src="https://www.labitacoradecarlosyeli.com/wp-content/uploads/2021/07/2-playas-imperdibles-si-estas-en-Santa-Marta-Colombia-Cabezote-1.jpg" alt=""/>
        </section>
        <section>
        <h2 className='titulociudadI'>Santa Marta</h2>
        <p className='parrafociudadI'>Santa Marta, oficialmente Distrito Turístico, Cultural e Histórico de Santa Marta,4​ es la capital del departamento de Magdalena, Colombia. Fue fundada el 29 de julio de 1525 por el español Rodrigo de Bastidas, lo que según los textos, la hace la ciudad en pie más antigua de Colombia. Se encuentra a orillas de la bahía del mismo nombre. Es conocida por sus actividades turísticas, la historia de sus calles y sus playas.   </p>
        </section>
      </div>
      <div className='ciudadDerecha'>
        <section>
        <h2 className='titulociudadD'>Cartagena</h2>
        <p className='parrafociudadD'>Cartagena es una ciudad portuaria en la costa caribeña de Colombia. Junto al mar, se encuentra la Ciudad Vieja amurallada, que se fundó en el siglo XVI, con plazas, calles de adoquines y edificios coloniales coloridos. Con un clima tropical, la ciudad también es un destino popular por sus playas. Se puede llegar en bote a la Isla de Barú, con playas de arena blanca y palmeras, y a las Islas del Rosario, famosas por sus arrecifes de coral.</p>
        </section>
        <section>
        <img className='imagenciudadD' src="https://http2.mlstatic.com/D_NQ_NP_688002-MCO46152356538_052021-O.jpg" alt="" />
        </section>
      </div>
      <div className='ciudadIzquierdaI'>
        <section>
        <img className='imagenciudadI' src="https://i0.wp.com/www.medellindaytrips.com/wp-content/uploads/2018/04/Featured-Image-Comuna-13-article.jpg?fit=2560%2C1536&ssl=1" alt="" />
        </section>
        <section>
        <h2 className='titulociudadI'>Comuna 13 (Medellín)</h2>
        <p className='parrafociudadI'>Catalogada como un must-see en Colombia por un sinnúmero de guías de viajes en internet, La Comuna 13 de Medellín sorprende por su historia de resiliencia y transformación social, por una vida de barrio tan genuina como los habitantes que acogen con amabilidad a los visitantes que llegan para recorrerla. Aunque al principio es insospechable, solo basta con poner un pie en el barrio para empezar a ser consciente de las innumerables experiencias y expresiones que allí se gestan.   </p>
        </section>
      </div>
      <div className='ciudadDerecha'>
        <section>
        <h2 className='titulociudadD'>Coveñas</h2>
        <p className='parrafociudadD'>Coveñas es una ciudad turística del Golfo de Morrosquillo en el norte de Colombia. Es conocida por sus largas playas con aguas tranquilas y poco profundas. La playa Primera Ensenada es un centro de deportes acuáticos. Al noreste de la ciudad, la Ciénaga de la Caimanera es una laguna costear con abundante fauna y una reserva natural con mangles, caimanes y una variedad de peces y aves. Al suroeste está el pueblo de San Antero, conocido por su Festival del Burro anual.</p>
        </section>
        <section>
        <img className='imagenciudadD' src="https://http2.mlstatic.com/D_NQ_NP_688002-MCO46152356538_052021-O.jpg" alt="" />
        </section>
      </div>
      <div className='ciudadIzquierdaI'>
        <section>
        <img className='imagenciudadI' src="https://i.ytimg.com/vi/sJVRvhsEDk0/maxresdefault.jpg" alt="" />
        </section>
        <section>
        <h2 className='titulociudadI'>Piscilago</h2>
        <p className='parrafociudadI'>Piscilago es un parque acuático y recreativo ubicado en el municipio de Melgar en el Tolima, un destino de diversión y relajación con un clima caluroso en promedio unos 28º C, ideal para disfrutar en familia, amigos y conocidos, disfrutando de sus toboganes extremos, diversidad de piscinas así como de la naturaleza. Piscilago hace parte la Caja de Compensación Colsubsidio, por lo que sus afiliados tienen precios especiales, pero la admisión es para todo público, así no estés afiliado a la caja de compensación.</p>
        </section>
      </div>
      <div className='ciudadDerecha'>
        <section>
        <h2 className='titulociudadD'>Estadio metropolitano de Barranquilla</h2>
        <p className='parrafociudadD'>El Estadio Metropolitano Roberto Meléndez es un escenario para la práctica del fútbol y el atletismo en Barranquilla, Colombia. Fue inaugurado el 11 de mayo de 1986, sustituyendo al estadio Romelio Martínez como principal escenario para la práctica del fútbol y como sede del Junior de Barranquilla.</p>
        </section>
        <section>
        <img className='imagenciudadD' src="https://www.barranquilla.gov.co/wp-content/uploads/2020/01/recorrido_obras_metropolitano-5_-portada.jpg" alt="" />
        </section>
      </div>
      <div className='ciudadIzquierdaI'>
        <section>
        <img className='imagenciudadI' src="https://www.civitatis.com/f/colombia/cartagena-de-indias/galeria/volcan-totumo.jpg" alt="" />
        </section>
        <section>
        <h2 className='titulociudadI'>Volcán del Totumo</h2>
        <p className='parrafociudadI'>El volcán del Totumo es un cono volcánico lleno de lodo, que se encuentra ubicado en la zona rural del municipio de Santa Catalina, en la Región Caribe de Colombia, junto a la Ciénaga del Totumo y cerca de la frontera con el departamento del Atlántico.</p>
        </section>
      </div>
      <div className='ciudadDerecha'>
        <section>
        <h2 className='titulociudadD'>Piedra del Peñol</h2>
        <p className='parrafociudadD'>El peñón de Guatapé, o piedra del Peñol, es un monolito de 220 metros de altura, localizado en el término municipal de Guatapé, Antioquia, Colombia.1​ La piedra de El Peñol es una masa granítica, compuesta por cuarzo, feldespato y mica, fue escalada por primera vez en 16 de julio de 1954 por un habitante de la zona, Luis Eduardo Villegas López. Actualmente se puede acceder a su cumbre subiendo los 715 escalones construidos en el monolito.</p>
        </section>
        <section>
        <img className='imagenciudadD' src="https://media.tacdn.com/media/attractions-splice-spp-674x446/06/e4/7b/b5.jpg" alt="" />
        </section>
      </div>
    </div>
  )
}